<template>
     <div class="preloader" v-if="isCanvasLoaded">
        <div class="inside">
          <div class="leaf" :class="{'hide' : prc === 100}">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20.989" height="16.011" viewBox="0 0 20.989365 16.010891"><defs><path id="a" d="M0 0h1280v800H0z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible" width="100%" height="100%"/></clipPath><g clip-path="url(#b)" transform="translate(-621.03 -386.895)"><defs><path id="c" d="M-9.083-5.833h1280v800h-1280z"/></defs><clipPath id="d"><use xlink:href="#c" overflow="visible" width="100%" height="100%"/></clipPath><path clip-path="url(#d)" d="M635.913 399.384c-4.19 2.96-7.787 2.88-9.978.955-.342-.547.248-.983.82-1.418l14.08-9.95c-.157 1.947-.996 7.634-4.922 10.41m-11.23-.735c-1.184-2.636-.137-5.996 4.055-8.958 3.925-2.775 9.718-1.773 11.663-1.308l-14.08 9.95c-.603.395-1.21.805-1.636.315m17.335-10.896c-.03-.042-8.548-2.56-13.93 1.245-5.078 3.586-6.06 7.705-4.224 10.777l-.38-.38s-1.015.232-2.456 1.343c.665.034.84.91 1.292 1.108.808-.474 1.802-1.174 2.072-1.313 2.353 2.938 6.795 3.475 12.055-.243 5.383-3.805 5.6-12.492 5.567-12.535" clip-rule="evenodd" fill="#ef4e23" fill-rule="evenodd"/></g><g clip-path="url(#b)" transform="translate(-621.03 -386.895)"><defs><path id="e" d="M628.677 389.725c-4.236 3.006-5.296 6.417-4.097 9.095.428.497 1.04.08 1.65-.32l14.232-10.105c-.93-.223-2.75-.57-4.818-.57-2.285 0-4.887.42-6.967 1.9"/></defs><clipPath id="f"><use xlink:href="#e" overflow="visible" width="100%" height="100%"/></clipPath><g clip-path="url(#f)"><defs><path id="g" d="M622.987 387.538h18.052v12.36h-18.054z"/></defs><clipPath id="h"><use xlink:href="#g" overflow="visible" width="100%" height="100%"/></clipPath><g clip-path="url(#h)"><image overflow="visible" width="63" height="43" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAxCAYAAABnCd/9AAAACXBIWXMAACaZAAAmmQHgIlaIAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoxJREFUeNrsWU1KXEEQrp8ecQai m1kEvIBHCLmEhJwn18gu+5wi5ABuA7MIBBQMIUTciKLzutI/r33qvGdXNll0vYIe7Zne1MdX9X3V DTDHHHPMMcd/D3y8udt8fX375dO77urXW3B77Wff3QMfrs/d0fFZ2J2uTj6clp/ck4N31wfd5eWb 7s/Fe1xQ87jI1gNsZUOv1puw/R3BGQcGEZC3C3R+icztM0YEgP0CaJcEO8CEbySxxbUPDKIPRAgf zF2E6UVghPICwvYZ0+cqI6m6ERiH1T5lJnPdLSWEYVnQ5Ik8R4ChQC8Kf8hAKdGwaqX00F+M9Ji0 UMEYTIfHUWyTMblKXgQmARcPxXJCMsGYlKeq+UYE2UaPEVH2GIHew/R+pn1kMlukpkqSGBMcbxwH yMJI4FN1qFTJnsHTAFMYQy6cdwZ6jM+g1FSJolz3ko1sQJUgg4I1Vco9JlNLLPgY6dW3KtcJxL7x WvAxyNqRoDCGAy7tq5KA70mgmq7JzkjQ+5hq802M6UcCG6VUcq0xhoZSEgsGr5SSqscg2+kx0ul8 TAIm+hc2ItegVaVHPgasGDyVj0F46DFghjFcL6V07YD58gbRQPNFn3KVGmPijERheBR2Ni6qgFOe qFGlctDEE22Q65wv1oGBgqABxqCwUq4RbI0EWlWKd58+0MobeXCTAAypp2tLzyfaWWlovHYYk2/v KsB4kTQKiBGDF4GRNDBrRgI0dLUJ5YlWIddSQDECjEyQYOJdyZBco8rHxGtzTx624d/2YREJeYJf iHTL51g8VSXev6XV+pzZfQN0BpDpgPYOvtP+4Y+wu5pmDLmf4JYfyd9/BrTxdo1udRMIcfMcmDnm +Lf4K8AAmMmIPH3MiS4AAAAASUVORK5CYII=" transform="matrix(.2865 0 0 -.2875 622.987 399.898)"/></g></g></g><g clip-path="url(#b)" transform="translate(-621.03 -386.895)"><defs><path id="i" d="M626.555 399.15c-.58.443-1.175.882-.828 1.437 2.215 1.953 5.85 2.036 10.084-.972 3.97-2.82 4.816-8.592 4.976-10.57l-14.23 10.104z"/></defs><clipPath id="j"><use xlink:href="#i" overflow="visible" width="100%" height="100%"/></clipPath><g clip-path="url(#j)"><defs><path id="k" d="M624.964 388.714h16.48v14.323h-16.48z"/></defs><clipPath id="l"><use xlink:href="#k" overflow="visible" width="100%" height="100%"/></clipPath><g clip-path="url(#l)"><image overflow="visible" width="58" height="50" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA1CAYAAAD2xDO5AAAACXBIWXMAACboAAAm6AEWeMBbAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoRJREFUeNrsWkuKG0EMrSdVGw+B DMx+yDYHmENknXvkFLlCDpFdIJBzzGYWs8gyDISEWUwgH2K3Ul3V/nXKbvXSzy4Q2E1tXkt6epI6 hPM5zYPhg58f394svty/bp++XwdtOFCahRCbP2jmHy7fvP+0ehyH9xLoF8vHb6+Wjw8v0QgNeDSz JWbzz+nffvBBEmBtG0S7gIIkwJPnFb8ztq1TAa8GQYuYLkYlwd45VNtsh8Abyt3OgoAn7IGEaRdP PanTxWxEvJ6dOYAUq8Brv4895ysOrYPviGFlJNgD/scT94Z8NiI5I27PoysNRJ4vhIcx8JIAp1K3 NhaBh4xrJOytY8aUH20ygMTzCZUlr8uY53Odz/kuNGyf+a6r8+PgN2xvwuP5oG627wUBjcLbIvLD 2l76mqhUbB+gBZdP5ICG8Cy0xet+kcNDeAjik7fogdfq4vFGveUoxljYZyUk2JQ7jp6u2qvsCXu2 xsaqaVyp8z3bJ3Y0IoWHFS6X54nkraEPe6izqyMKe5g75/tLSpbzvXZxh31WeRTg2ymTHCUjPHgJ T9Y5D7awHwUvjAPMKYQHsn5+JXKmTW95Fhd5Jjlpbs9CeHDK222RA6Yx1qTGBoSEByfhQZQv7MXV z2tmerAovDzGciwtSr6jXKTJeefGZndLy1LqZO1UR85zjbHKfl7C8FuM0xhj5VKnE/p5pqVFt6j0 9POGsqU1Jnlrpa11KLz+DYFM3gp8A8zseaKPEwrhO8OebkVttiHyMYW3U+tPaZhh1qqFbGXwR8J4 CG1jtoyHc765+IXZs6+wxWVA5AEv8W+Q+OMgeJk9v5P51TtoczXccBz30UUCfxvO53zCPwEGALgk kiMRmnxMAAAAAElFTkSuQmCC" transform="matrix(.2842 0 0 -.2865 624.964 403.037)"/></g></g></g></svg>
          </div>
          <div class="c100 small" :class="['p' + prc, {'hide': prc === 100}]">
                <span>
                </span>
                <div class="slice">
                    <div class="bar"></div>
                    <div class="fill">
                    </div>
                </div>
            </div>
            <div class="text" :class="{'hide': prc === 100}">Loading assets...</div>
        </div>
     </div>
</template>

<script>

const ASSETS = [
  '/img/favicon.png',
  '/textures/brown.jpg',
  '/textures/brown2.jpg',
  '/textures/grass.jpg',
  '/textures/grass2.jpg',
  '/textures/grass3.jpg',
  '/textures/grass4.jpg',
  '/textures/grass5.jpg',
  '/textures/grass6.jpg',
  '/textures/sand.jpg',
  '/textures/street.jpg',
  '/textures/water.jpg',
  '/img/about-us/header.jpg',
  '/img/about-us/team1.jpg',
  '/img/about-us/team2.jpg',
  '/img/about-us/team3.jpg',
  '/img/about-us/team4.jpg',
  '/img/about-us/team5.jpg',
  '/img/about-us/team6.jpg',
  '/img/about-us/team7.jpg',
  '/img/about-us/team8.jpg',
  '/img/about-us/team9.jpg',  
  '/img/about-us/why-us.jpg',
  '/img/blog/post.jpg',
  '/img/menu.jpg',
  '/img/orange-bg.jpg',
  '/img/product/bottom-last-airport.jpg',
  '/img/product/bottom-last.jpg',
  '/img/product/header-airport.jpg',
  '/img/product/header.jpg',
  '/img/product/image-box-1.jpg',
  '/img/product/image-box-2-airport.jpg',
  '/img/product/image-box-2.jpg',
  '/img/product/image-box-3.jpg',
  '/img/product/image-box-4-airport.jpg',
  '/img/product/image-box-4.jpg',
  '/img/product/image-box-5.jpg',
  '/img/product/image1-airport.jpg',
  '/img/product/image1.jpg',
  '/img/product/image2-airport.jpg',
  '/img/product/image2.jpg',
  '/img/product/image3-airport.jpg',
  '/img/product/image3.jpg',
  '/img/product/tablet.jpg',
  '/img/video.jpg',
  '/img/about-us/our-team-bg.png',
  '/img/blog/bg.png',
  '/img/favicon.png',
  '/img/fb-blue.png',
  '/img/linked-blue.png',
  '/img/fb.png',
  '/img/linked.png',
  '/img/logo.png',
  '/img/product/bottom-first.png',
  '/img/question-modal-bg.png',
  '/img/contact/adress.svg',
  '/img/contact/mail.svg',
  '/img/contact/marker.svg',
  '/img/contact/phone.svg',
  '/img/hexagon.svg',
  '/img/home/airport.svg',
  '/img/home/area.svg',
  '/img/home/wind-farm.svg',
  '/img/soppo-logo.svg'
]

import {isCanvasVisible} from '../helpers/helpers';

export default {
  name: 'preloader',
  data () {
    return {
      // prc: 0,
      PxLoader: null,
      animationLoaded: false,
      imagesElements: {loaded: 0, all: 0},
      threejsElements: {loaded: 0, all: 0},
      loadedItems: 0,
      allItems: ASSETS.length + 1, // 1 animation json
      animJsonLoaded: false,
    }
  },
  computed: {
    isCanvasLoaded() {
        if (this.$store.state.isCanvasLoaded && !this.animationLoaded) {
          this.animationLoaded = true;
          // store.commit('LOAD_ANIMATION', this.animJSONCallback)
          store.commit('LOAD_ANIMATION_OBJECTS', this.animCallback)
          this.loaad
        }
        return this.$store.state.isCanvasLoaded;
    },
    prc() {
      const prc = Math.ceil(( this.imagesElements.loaded + this.threejsElements.loaded +( (this.animJsonLoaded) ? 1 : 0)) / (this.allItems + this.threejsElements.all) * 100)
      if (prc === 100) {
        store.commit('SHOW_LOADER_FINISH', () => {
          if (!isCanvasVisible(this.$route.name)) {
            store.commit('HIDE_CANVAS');
          }
        })
        store.commit('INIT_GROUNDS')
      }
      return prc
    }
  },
  
  mounted: function() {
    this.PxLoader = new PxLoader();
    const PATH = "/static";
    ASSETS.map((a) => {
      this.PxLoader.addImage(PATH + a);
    })
    this.PxLoader.addProgressListener(this.loderProgress)
    this.PxLoader.addCompletionListener(this.imagesLoaded)
    // this.PxLoader.start();

  },
  methods: {
    imagesLoaded: function(e) {
      // console.log('images loaded')
      this.animatinLoad();
    },
    loderProgress: function(e) {
      // this.prc = e.completedCount / e.totalCount * 100
      this.imagesElements.loaded = e.completedCount;
      this.imagesElements.all = e.totalCount;
      // console.log(e.completedCount + '/' + e.totalCount);
    },
    animCallback: function(current, all) {
      this.threejsElements.loaded = current;
      this.threejsElements.all = all;
      if (current === all) {
        this.PxLoader.start();
      }
      // console.log((this.imagesElements.loaded + this.threejsElements.loaded) + ' / ' + (this.imagesElements.all + this.threejsElements.all))
    },
    animJSONCallback: function() {
      this.animJsonLoaded = true;
    },
    animatinLoad: function() {

      const link = '/static/animation/anim.json';
      this.$store.commit('LOAD_ANIMATION', {
          link: link,
          cb: () => {
            this.animJsonLoaded = true
          }
      })
    }
  }
}
</script>

<style scoped>
  .preloader {
  }
  .leaf {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    width: 80px;
    height: 80px;
    z-index: 10;
    transition: all 0.4s 0.4s
  }
  .leaf svg{
      position: absolute;
      width: 20px;
      height: 16px;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
  }  
  .leaf.hide {
    transform: scale(3);
    opacity: 0;
  }
  .preloader .inside .box {
    border-radius: 50%;
    background: initial;
    border: 3px solid #999;
    width: 100px;
    height: 100px;
    position: relative;
  }
  .preloader .inside .box:after {
    content: "";
    display: block;
    border-right: 3px solid red;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    margin: auto;
  }
  .text {
    font-size: 14px;
    text-align: center;
    margin-top: 30px;
    color: #999;
    transition: opacity 0.2s;
  }
  .text.hide {
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// Preloader.vue?476306a5